export const ProductRulesEnum = Object.freeze({
  PreferredProductId: 0,
  FinalCheckValue: 1,
  BlockClaim: 2,
  ForceDispensing: 3,
  ClinicalCheckWarning: 4,
  LabellingWarning: 5,
  MobileHandoutAlert: 6,
});
